import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Calendar, Clock, Mail, MessageSquare, Link2, Send, Eye, ArrowLeft, Check, X } from 'lucide-react';
import AdminNav from './AdminNav';

const DecisionTree: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-900">
      <AdminNav
        title="Decision Tree"
        description="View static decision tree visualization"
      />
      <div className="bg-gradient-to-br from-amber-50 via-orange-50 to-rose-50 p-8">
        <div className="max-w-7xl mx-auto">

        <div className="bg-white rounded-3xl shadow-xl p-8">
          {/* Decision Tree SVG */}
          <svg viewBox="0 0 1200 1600" className="w-full h-auto">
            <defs>
              <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#fbbf24" />
                <stop offset="100%" stopColor="#f97316" />
              </linearGradient>
              <linearGradient id="gradient2" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#a78bfa" />
                <stop offset="100%" stopColor="#8b5cf6" />
              </linearGradient>
              <linearGradient id="gradient3" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#34d399" />
                <stop offset="100%" stopColor="#10b981" />
              </linearGradient>
            </defs>

            {/* Step 1: Who's Birthday */}
            <rect x="450" y="20" width="300" height="80" rx="15" fill="url(#gradient1)" />
            <text x="600" y="50" textAnchor="middle" fill="white" fontSize="18" fontWeight="bold">Step 1: Who's Birthday?</text>
            <text x="600" y="75" textAnchor="middle" fill="white" fontSize="14">Enter recipient name</text>

            {/* Arrow down */}
            <line x1="600" y1="100" x2="600" y2="140" stroke="#666" strokeWidth="2" markerEnd="url(#arrowhead)" />

            {/* Step 2: Birthday Date */}
            <rect x="450" y="140" width="300" height="80" rx="15" fill="url(#gradient1)" />
            <text x="600" y="170" textAnchor="middle" fill="white" fontSize="18" fontWeight="bold">Step 2: When's Birthday?</text>
            <text x="600" y="195" textAnchor="middle" fill="white" fontSize="14">Select month & day</text>

            {/* Three branches from Step 2 */}
            <line x1="500" y1="220" x2="300" y2="280" stroke="#666" strokeWidth="2" />
            <line x1="600" y1="220" x2="600" y2="280" stroke="#666" strokeWidth="2" />
            <line x1="700" y1="220" x2="900" y2="280" stroke="#666" strokeWidth="2" />

            {/* Branch 1: Belated */}
            <rect x="150" y="280" width="200" height="60" rx="10" fill="#fbbf24" />
            <text x="250" y="305" textAnchor="middle" fontSize="14" fontWeight="bold">Belated (Past 30 days)</text>
            <text x="250" y="325" textAnchor="middle" fontSize="12">Shows belated messages</text>

            {/* Branch 2: Today */}
            <rect x="500" y="280" width="200" height="60" rx="10" fill="#10b981" />
            <text x="600" y="305" textAnchor="middle" fontSize="14" fontWeight="bold">Today</text>
            <text x="600" y="325" textAnchor="middle" fontSize="12">Send immediately</text>

            {/* Branch 3: Upcoming */}
            <rect x="850" y="280" width="200" height="60" rx="10" fill="url(#gradient2)" />
            <text x="950" y="305" textAnchor="middle" fill="white" fontSize="14" fontWeight="bold">Upcoming</text>
            <text x="950" y="325" textAnchor="middle" fill="white" fontSize="12">Schedule option</text>

            {/* Upcoming branches */}
            <line x1="900" y1="340" x2="850" y2="400" stroke="#666" strokeWidth="2" />
            <line x1="1000" y1="340" x2="1050" y2="400" stroke="#666" strokeWidth="2" />

            <rect x="780" y="400" width="140" height="50" rx="8" fill="#8b5cf6" />
            <text x="850" y="430" textAnchor="middle" fill="white" fontSize="12">Schedule for date</text>

            <rect x="980" y="400" width="140" height="50" rx="8" fill="#6366f1" />
            <text x="1050" y="430" textAnchor="middle" fill="white" fontSize="12">Send now</text>

            {/* Converge to Step 3 */}
            <line x1="250" y1="340" x2="400" y2="500" stroke="#666" strokeWidth="2" />
            <line x1="600" y1="340" x2="600" y2="500" stroke="#666" strokeWidth="2" />
            <line x1="850" y1="450" x2="700" y2="500" stroke="#666" strokeWidth="2" />
            <line x1="1050" y1="450" x2="700" y2="500" stroke="#666" strokeWidth="2" />

            {/* Step 3: Delivery Method */}
            <rect x="450" y="500" width="300" height="80" rx="15" fill="url(#gradient1)" />
            <text x="600" y="530" textAnchor="middle" fill="white" fontSize="18" fontWeight="bold">Step 3: Delivery Method</text>
            <text x="600" y="555" textAnchor="middle" fill="white" fontSize="14">How to reach them?</text>

            {/* Four delivery options */}
            <line x1="450" y1="580" x2="300" y2="640" stroke="#666" strokeWidth="2" />
            <line x1="550" y1="580" x2="500" y2="640" stroke="#666" strokeWidth="2" />
            <line x1="650" y1="580" x2="700" y2="640" stroke="#666" strokeWidth="2" />
            <line x1="750" y1="580" x2="900" y2="640" stroke="#666" strokeWidth="2" />

            <rect x="230" y="640" width="120" height="50" rx="8" fill="#3b82f6" />
            <text x="290" y="670" textAnchor="middle" fill="white" fontSize="12">Email</text>

            <rect x="430" y="640" width="120" height="50" rx="8" fill="#10b981" />
            <text x="490" y="670" textAnchor="middle" fill="white" fontSize="12">SMS</text>

            <rect x="630" y="640" width="120" height="50" rx="8" fill="#059669" />
            <text x="690" y="670" textAnchor="middle" fill="white" fontSize="12">WhatsApp</text>

            <rect x="830" y="640" width="120" height="50" rx="8" fill="#8b5cf6" />
            <text x="890" y="670" textAnchor="middle" fill="white" fontSize="12">Share Link</text>

            {/* Contact info or skip */}
            <line x1="290" y1="690" x2="400" y2="750" stroke="#666" strokeWidth="2" />
            <line x1="490" y1="690" x2="450" y2="750" stroke="#666" strokeWidth="2" />
            <line x1="690" y1="690" x2="500" y2="750" stroke="#666" strokeWidth="2" />
            <line x1="890" y1="690" x2="890" y2="750" stroke="#666" strokeWidth="2" strokeDasharray="5,5" />

            <rect x="350" y="750" width="200" height="60" rx="10" fill="#94a3b8" />
            <text x="450" y="780" textAnchor="middle" fontSize="14">Step 4: Contact Info</text>
            <text x="450" y="795" textAnchor="middle" fontSize="11">(Email/Phone)</text>

            <rect x="790" y="750" width="200" height="60" rx="10" fill="#cbd5e1" />
            <text x="890" y="780" textAnchor="middle" fontSize="14">Skip to Link Gen</text>
            <text x="890" y="795" textAnchor="middle" fontSize="11">(Copy & Share)</text>

            {/* Continue flow */}
            <line x1="450" y1="810" x2="600" y2="860" stroke="#666" strokeWidth="2" />
            <line x1="890" y1="810" x2="600" y2="860" stroke="#666" strokeWidth="2" />

            {/* Remaining steps */}
            <rect x="450" y="860" width="300" height="60" rx="10" fill="#f59e0b" />
            <text x="600" y="885" textAnchor="middle" fontSize="14" fontWeight="bold">Step 5: Your Name</text>
            <text x="600" y="905" textAnchor="middle" fontSize="12">Sender identification</text>

            <line x1="600" y1="920" x2="600" y2="960" stroke="#666" strokeWidth="2" />

            <rect x="450" y="960" width="300" height="60" rx="10" fill="#ec4899" />
            <text x="600" y="985" textAnchor="middle" fontSize="14" fontWeight="bold">Step 6: Birthday Message</text>
            <text x="600" y="1005" textAnchor="middle" fontSize="12">AI suggestions (regular/belated)</text>

            <line x1="600" y1="1020" x2="600" y2="1060" stroke="#666" strokeWidth="2" />

            <rect x="450" y="1060" width="300" height="60" rx="10" fill="#8b5cf6" />
            <text x="600" y="1085" textAnchor="middle" fill="white" fontSize="14" fontWeight="bold">Step 7: Add Coffee?</text>
            <text x="600" y="1105" textAnchor="middle" fill="white" fontSize="12">Optional gift amount</text>

            <line x1="600" y1="1120" x2="600" y2="1160" stroke="#666" strokeWidth="2" />

            <rect x="450" y="1160" width="300" height="60" rx="10" fill="#06b6d4" />
            <text x="600" y="1185" textAnchor="middle" fill="white" fontSize="14" fontWeight="bold">Step 8: Preview Card</text>
            <text x="600" y="1205" textAnchor="middle" fill="white" fontSize="12">See how it looks</text>

            <line x1="600" y1="1220" x2="600" y2="1260" stroke="#666" strokeWidth="2" />

            <rect x="450" y="1260" width="300" height="60" rx="10" fill="url(#gradient3)" />
            <text x="600" y="1285" textAnchor="middle" fill="white" fontSize="14" fontWeight="bold">Step 9: Review & Send</text>
            <text x="600" y="1305" textAnchor="middle" fill="white" fontSize="12">Final confirmation</text>

            {/* Success states */}
            <line x1="500" y1="1320" x2="400" y2="1380" stroke="#666" strokeWidth="2" />
            <line x1="700" y1="1320" x2="800" y2="1380" stroke="#666" strokeWidth="2" />

            <rect x="300" y="1380" width="200" height="80" rx="15" fill="#10b981" />
            <text x="400" y="1410" textAnchor="middle" fill="white" fontSize="14" fontWeight="bold">Sent/Scheduled</text>
            <text x="400" y="1430" textAnchor="middle" fill="white" fontSize="12">"Birthday Joy Sent!"</text>
            <text x="400" y="1450" textAnchor="middle" fill="white" fontSize="12">"Scheduled for [date]"</text>

            <rect x="700" y="1380" width="200" height="80" rx="15" fill="#8b5cf6" />
            <text x="800" y="1410" textAnchor="middle" fill="white" fontSize="14" fontWeight="bold">Link Ready</text>
            <text x="800" y="1430" textAnchor="middle" fill="white" fontSize="12">"Birthday Card Ready!"</text>
            <text x="800" y="1450" textAnchor="middle" fill="white" fontSize="12">Copy & share options</text>

            {/* Arrow marker */}
            <defs>
              <marker id="arrowhead" markerWidth="10" markerHeight="7" refX="9" refY="3.5" orient="auto">
                <polygon points="0 0, 10 3.5, 0 7" fill="#666" />
              </marker>
            </defs>
          </svg>

          {/* Legend */}
          <div className="mt-8 p-6 bg-gray-50 rounded-xl">
            <h3 className="text-xl font-bold text-gray-800 mb-4">Key Decision Points</h3>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 bg-orange-500 rounded"></div>
                <span className="text-sm">User Input Steps</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 bg-purple-500 rounded"></div>
                <span className="text-sm">Scheduling Decision</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 bg-green-500 rounded"></div>
                <span className="text-sm">Success States</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 bg-yellow-500 rounded"></div>
                <span className="text-sm">Conditional Logic</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 bg-blue-500 rounded"></div>
                <span className="text-sm">Delivery Methods</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 bg-gray-500 rounded"></div>
                <span className="text-sm">Optional Paths</span>
              </div>
            </div>
          </div>

          {/* Language Logic */}
          <div className="mt-8 p-6 bg-gradient-to-r from-amber-50 to-orange-50 rounded-xl">
            <h3 className="text-xl font-bold text-gray-800 mb-4">Language Decision Tree</h3>
            <div className="space-y-4 text-sm">
              <div>
                <strong>If Birthday = Today:</strong>
                <ul className="ml-4 mt-2 space-y-1">
                  <li>• Messages: Regular birthday wishes</li>
                  <li>• Button: "Send Birthday Card"</li>
                  <li>• Success: "Birthday Joy Sent!"</li>
                </ul>
              </div>
              <div>
                <strong>If Birthday = Past (Belated):</strong>
                <ul className="ml-4 mt-2 space-y-1">
                  <li>• Messages: Belated birthday wishes</li>
                  <li>• Button: "Send Belated Card"</li>
                  <li>• Success: "Belated Wishes Sent!"</li>
                </ul>
              </div>
              <div>
                <strong>If Birthday = Future + Scheduled:</strong>
                <ul className="ml-4 mt-2 space-y-1">
                  <li>• Messages: Regular birthday wishes</li>
                  <li>• Button: "Schedule Birthday Card"</li>
                  <li>• Success: "Scheduled for [Date]!"</li>
                  <li>• Show: Reminder set confirmation</li>
                </ul>
              </div>
              <div>
                <strong>If Birthday = Future + Send Now:</strong>
                <ul className="ml-4 mt-2 space-y-1">
                  <li>• Messages: Early birthday wishes</li>
                  <li>• Button: "Send Early Birthday Card"</li>
                  <li>• Success: "Early Birthday Wishes Sent!"</li>
                </ul>
              </div>
              <div>
                <strong>If Delivery = Share Link:</strong>
                <ul className="ml-4 mt-2 space-y-1">
                  <li>• Button: "Create Birthday Card"</li>
                  <li>• Success: "Birthday Card Ready!"</li>
                  <li>• Show: Copy link & share options</li>
                </ul>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DecisionTree;